import React from 'react';
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";

const NewTeammateDetail = ({
    newUserData,
    setNewUserData,
    tempPassword
}) => {

    console.log("newUserData",newUserData);

    const history = useHistory();

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     if (name === 'unrestrictedaccess') {
    //         setNewUserData(prev => ({ ...prev, [name]: !prev.unrestrictedaccess }));
    //     } else {
    //         setNewUserData(prev => ({ ...prev, [name]: value }));
    //     }
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setNewUserData((prev) => {
            if (name === "responsibilities") {
                return {
                    ...prev,
                    responsibilities: value,                   
                    unrestrictedaccess: value === "unrestrictedaccess",
                };
            } else {
                return {...prev,[name]: value,};
            }
        });
    };



    return (
        <>
            <div className={adminPortalCss.dataCard}>
                <span className={`${adminPortalCss.msHeadingText} ${adminPortalCss.msGdHeading}`}>Let’s start with your details</span>
                <div className={adminPortalCss.msGeneraldetailLayout}>
                    <div className={adminPortalCss.msGeneraldetailContainer}>
                        <div className={adminPortalCss.msGeneraldetailInput}>
                            <InputGroup
                                label="Email Id"
                                req={true}
                                inputs={[
                                    <>
                                        <input
                                            type="text"
                                            name="email"
                                            value={newUserData.email}
                                            onChange={handleInputChange}
                                        />
                                    </>,
                                ]}
                            />
                            <InputGroup
                                label="Username"
                                req={true}
                                inputs={[
                                    <>
                                        <input
                                            type="text"
                                            name="name"
                                            value={newUserData.name}
                                            onChange={handleInputChange}
                                        />
                                    </>,
                                ]}
                            />
                            <InputGroup
                                label="Role"
                                req={true}
                                inputs={[
                                    <>
                                        <input
                                            type="text"
                                            name="role"
                                            value={newUserData.role}
                                            onChange={handleInputChange}
                                        />
                                    </>,
                                ]}
                            />
                            {tempPassword && (
                                <span
                                    style={{
                                        color:"#33584E",
                                        fontSize:"14px"
                                    }}
                                >Temporary Password : {tempPassword}</span>
                            )}
                            <div className={adminPortalCss.dFlexClm}>
                                <label className={`${adminPortalCss.customLabel} mt-2`}>
                                    <span style={{color:"red"}}>*</span> Choose responsibilities
                                </label>
                                <div className={adminPortalCss.radioButtonSection}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="responsibilities"
                                        value={newUserData.responsibilities}
                                        onChange={handleInputChange}
                                        className={adminPortalCss.radioSection}
                                    >
                                        <FormControlLabel
                                            value="preparer"
                                            className={adminPortalCss.radioLabel}
                                            control={
                                                <Radio
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 18,
                                                        },
                                                        color: "#D6D6D6",
                                                        "&.Mui-checked": { color: "#3AB67D" },
                                                    }}
                                                />
                                            }
                                            label="Preparer"
                                        />
                                        <FormControlLabel
                                            className={adminPortalCss.radioLabel}
                                            value="approver"
                                            control={
                                                <Radio
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 18,
                                                        },
                                                        color: "#D6D6D6",
                                                        "&.Mui-checked": { color: "#3AB67D" },
                                                    }}
                                                />
                                            }
                                            label="Approver"
                                        />
                                        <FormControlLabel
                                            className={adminPortalCss.radioLabel}
                                            value="view"
                                            control={
                                                <Radio
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 18,
                                                        },
                                                        color: "#D6D6D6",
                                                        "&.Mui-checked": { color: "#3AB67D" },
                                                    }}
                                                />
                                            }
                                            label="View"
                                        />
                                        <FormControlLabel
                                            className={adminPortalCss.radioLabel}
                                            value="unrestrictedaccess"
                                            control={
                                                <Radio
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 18,
                                                        },
                                                        color: "#D6D6D6",
                                                        "&.Mui-checked": { color: "#3AB67D" },
                                                    }}
                                                />
                                            }
                                            label="Unrestricted Access"
                                        />
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
            {/* <div className="mt-3">
                <label className="mt-2  font-size-12 custom-font-500 font-sans text-dark">
                    Mail ID <span className="text-danger">*</span>
                </label>
                <input
                    type="text"
                    className='radius-8px border-gray-300'
                    name="email"
                    value={newUserData.email}
                    onChange={handleInputChange}
                />
                <label className="mt-2 font-size-12 custom-font-500 font-sans text-dark">
                    User Name <span className="text-danger">*</span>
                </label>
                <input
                    type="text"
                    className='radius-8px border-gray-300'
                    name="name"
                    value={newUserData.name}
                    onChange={handleInputChange}
                />
                <label className="mt-2 font-size-12 custom-font-500 font-sans text-dark">
                    Role: <span className="text-danger">*</span>
                </label>
                <input
                    type="text"
                    className='radius-8px border-gray-300'
                    name="role"
                    value={newUserData.role}
                    onChange={handleInputChange}
                />
            </div>
            <div className="mt-3 d-flex align-items-center" >
                <label className='mb-0 font-size-12 custom-font-500 font-sans text-dark' > Unrestricted Access: </label>
                <input
                    className='m-0 ml-2'
                    type='checkbox'
                    name='unrestrictedaccess'
                    checked={newUserData.unrestrictedaccess}
                    onChange={handleInputChange}
                />
            </div>
            {
                !newUserData.unrestrictedaccess &&
                <div className=" mt-1" >
                    <FormControl>
                        <FormLabel
                            id="demo-row-radio-buttons-group-label"
                            className="font-size-12 custom-font-500 font-sans text-dark mt-3"
                        >
                            Responsibilities:
                        </FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="responsibilities"
                            className="p-1"
                            value={newUserData.responsibilities}
                            onChange={handleInputChange}
                        >
                            <FormControlLabel
                                className="font-size-16 custom-font-500 font-sans"
                                value="preparer"
                                control={
                                    <Radio
                                        sx={{
                                            color: "#D6D6D6",
                                            "&.Mui-checked": { color: "#03565A" },
                                        }}
                                    />
                                }
                                checked={newUserData.responsibilities === "preparer"}
                                label="Preparer"
                            />
                            <FormControlLabel
                                className="font-size-16 custom-font-500 font-sans"
                                value="approver"
                                control={
                                    <Radio
                                        sx={{
                                            color: "#D6D6D6",
                                            "&.Mui-checked": { color: "#03565A" },
                                        }}
                                    />
                                }
                                checked={newUserData.responsibilities === "approver"}
                                label="Approver"
                            />
                            <FormControlLabel
                                className="font-size-16 custom-font-500 font-sans"
                                value="view"
                                control={
                                    <Radio
                                        sx={{
                                            color: "#D6D6D6",
                                            "&.Mui-checked": { color: "#03565A" },
                                        }}
                                    />
                                }
                                checked={newUserData.responsibilities === "view"}
                                label="View"
                            />
                        //     {/* <FormControlLabel
                        //     className="font-size-16 custom-font-500 font-sans"
                        //     value="Unrestricted Access"
                        //     control={
                        //         <Radio
                        //             sx={{
                        //                 color: "#D6D6D6",
                        //                 "&.Mui-checked": { color: "#03565A" },
                        //             }}
                        //         />
                        //     }
                        //     label="Unrestricted Access"
                        // /> 
                        </RadioGroup>
                    </FormControl>
                </div>
            }
            <div className="d-flex justify-content-end">
                {childUserCount >= users ? (<Button
                    variant="contained"
                    className="font-size-16 custom-font-500 text-capitalize font-sans radius-10px custom-common-theme-bg-color"
                    style={{
                        width: "330px",
                        height: "55px",
                    }}
                    onClick={onClick}
                    disabled
                >
                    { newUserData.unrestrictedaccess ? "Create" : "Next"}
                </Button>)
                :
                (<Button
                    variant="contained"
                    className="font-size-16 custom-font-500 text-capitalize font-sans radius-10px custom-common-theme-bg-color"
                    style={{
                        width: "330px",
                        height: "55px",
                    }}
                    onClick={onClick}
                >
                    { newUserData.unrestrictedaccess ? "Create" : "Next"}
                </Button>)}
                
            </div> */}
        </>
    )
}

export default NewTeammateDetail